import { CHAT_MESSAGE_TYPES } from '../../../shared/constants'

export const getParticipants = participants => {
  const participantsType = participants[0].type
  const participantsIds = participants.map(({ id }) => id)
  return participantsType === 'CITY'
    ? { cityIds: participantsIds }
    : { endUserIds: participantsIds }
}

export const getMessageProps = ({
  messageData,
  currentConversation,
  author,
  currentUserId,
}) => {
  const { type } = messageData.payload
  const { firstName, lastName, cityName } = author

  const cityNameLabel = cityName ? `(${cityName})` : ''

  const basicProps = {
    id: messageData.id,
    authorId: messageData.userId,
    name: `${firstName} ${lastName} ${cityNameLabel}`,
    timestamp: messageData.timestamp,
    status:
      currentConversation.lastReadTime > messageData.timestamp
        ? 'READ'
        : 'UNREAD',
    isOwnMessage: messageData.userId == currentUserId,
    type,
    profilePicture: author.profilePicture,
  }

  if (type === CHAT_MESSAGE_TYPES.TEXT) {
    return {
      ...basicProps,
      text: messageData.payload.text,
    }
  } else if (
    [
      CHAT_MESSAGE_TYPES.IMAGE,
      CHAT_MESSAGE_TYPES.VIDEO,
      CHAT_MESSAGE_TYPES.FILE,
    ].includes(type)
  ) {
    return {
      ...basicProps,
      fileURL: messageData.payload.fileURL,
    }
  }
}

export const getProcessedMessages = ({
  currentConversation,
  messages,
  users,
  currentUserId,
}) => {
  return currentConversation.orderedMessages.reduceRight((acc, messageId) => {
    const messageData = messages[messageId]
    const { firstName = 'Loading...', lastName = '', cityName } = users[
      messageData.userId
    ]

    const messageProps = getMessageProps({
      messageData,
      currentConversation,
      author: {
        firstName,
        lastName,
        cityName,
      },
      currentUserId,
    })

    acc.push(messageProps)

    return acc
  }, [])
}
